import { UpdatePackRequestBody } from "../apis/useUpdatePack";
import { PackFormValues } from "../packs.types";

const toNumberOrZero = (value: unknown): number => {
  if (value == null || value === "") return 0;
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export const convertPackFormDataToUpdateRequestBody = (
  packId: string,
  formData: PackFormValues
): UpdatePackRequestBody => {
  return {
    id: packId,
    title: formData.title.trim(),
    shortId: formData.shortId.trim(),
    description: formData.description.trim(),
    mediaIds: formData.media.map((m) => m.id),
    previewId: formData.preview?.id ?? null,
    badgeId: formData.badgeId || undefined,
    price: Number(formData.price),
    merchantPrice: toNumberOrZero(formData.merchantPrice),
    intermediateResellerPrice: toNumberOrZero(formData.intermediateResellerPrice),
    confirmedResellerPrice: toNumberOrZero(formData.confirmedResellerPrice),
    influencerPrice: toNumberOrZero(formData.influencerPrice),
    recommendedSellingPrice: toNumberOrZero(formData.recommendedSellingPrice),
    commission: toNumberOrZero(formData.commission),
    commissionPercentage: toNumberOrZero(formData.commissionPercentage),
    influencerCommission: toNumberOrZero(formData.influencerCommission),
    influencerCommissionPercentage: toNumberOrZero(
      formData.influencerCommissionPercentage
    ),
    discount: toNumberOrZero(formData.discount),
    discountAmount: toNumberOrZero(formData.discountAmount),
    allowSellingBelowBuyingPrice: formData.allowSellingBelowBuyingPrice,
    isChapshopChoice: formData.isChapshopChoice,
    position: formData.position
  };
};
